import { useState } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

// User auth function to be used in the LoginCard
export const useAuth = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Login logic
    const login = async ({uname,upass}) => {
        const response = await fetch(`${API_BASE_URL}/auth/login`, {
            method: 'POST',
            credentials: 'include', // Required to send cookies
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uname, upass })
        });
        setUser(response.body.uid);
        return response
    }
    const verify = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/verify`, {
                method: 'GET',
                credentials: 'include' // Required to send cookies
            });
            return response.ok
            //setIsVerified(response.ok); // Set authentication status
        } catch (error) {
            console.error("Verification error:", error);
            return false;
            //setIsVerified(false);
        }
    };

    const logout = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/auth/logout`, {
            method: 'POST',
            credentials: 'include', // Ensures the cookie is sent for this request
            headers: { 'Content-Type': 'application/json' },
          });
      
          if (response.ok) {
            localStorage.clear();
            console.log('Logged out successfully');
	    return true;
          } else {
            console.error('Error logging out');
	    return false;
          }
        } catch (error) {
          console.error('Logout error:', error);
	  return false;
        }
    };

    return {
        user,
        isAuth: !!user,
        loading,
        login,
        logout,
        verify,
    }
}
